import React from 'react';
import { ArrowUpRight, Star } from 'lucide-react';
import { reviews } from '../data/reviews';
import { company } from '../data/company';
export function Reviews() {
  return <section id="reviews" className="border-t border-neutral-200 bg-white" data-id="element-179" data-mp="2mbp082p41ioy">
      <div className="mx-auto max-w-6xl px-6 py-20 lg:py-28" data-id="element-180" data-mp="2mdry18wi8g48">
        <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-181" data-mp="2rbtern6gk3cj">
          <div className="max-w-xl" data-id="element-182" data-mp="2waeivxotz769">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-neutral-500" data-id="element-183" data-mp="2w9d6npw2wemy">
              Reviews
            </p>
            <h2 className="mt-4 text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-184" data-mp="3093txjmeccmq">
              People keep asking for JR by name.
            </h2>
          </div>
          <a href={company.google} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-sm font-semibold text-ink underline decoration-gold decoration-2 underline-offset-[6px] hover:text-neutral-600" data-id="element-185" data-mp="3a0rmjnuovzps">
            Read reviews on Google
            <ArrowUpRight className="h-4 w-4" aria-hidden="true" data-id="element-186" data-mp="2rab0ahdytc09" />
          </a>
        </div>

        <ul className="mt-14 grid gap-6 lg:grid-cols-3" data-id="element-187" data-mp="2mfnh8y1qd9t2">
          {reviews.map(review => <li key={review.name} className="flex flex-col border-t-2 border-ink pt-6" data-id="element-188" data-mp="2hgkg3oovfnqd">
              <div className="flex gap-1" aria-label="Five out of five stars" data-id="element-189" data-mp="3a2vovmmmsuy9">
                {Array.from({
              length: 5
            }).map((_, i) => <Star key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-190" data-mp="355dgbxcj0hqs" data-mpi={i} />)}
              </div>
              <blockquote className="mt-5 flex-1 text-base leading-relaxed text-neutral-700" data-id="element-191" data-mp="2wb8p3cthd4aq">
                “{review.quote}”
              </blockquote>
              <footer className="mt-6" data-id="element-192" data-mp="3o2elpj9zsjv9">
                <p className="text-sm font-semibold text-ink" data-id="element-193" data-mp="3o1danesz7xdj">{review.name}</p>
                <p className="font-mono text-[10px] uppercase tracking-[0.16em] text-neutral-400" data-id="element-194" data-mp="1m6fif8b4bbyt">
                  {review.job}
                </p>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}